<template>
  
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-xbox-controller-menu</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="RepOrderStatus"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <div v-if="loading">
                <v-progress-linear  color="secondary" height="6" indeterminate rounded></v-progress-linear>
            </div>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-text-field type="number" v-model="editedItem.RepOrderStatus_id" variant="solo-filled" 
                increment="1"   label="Status Id" required readonly v-show="false"></v-text-field>

                <v-row>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editedItem.RepOrderStatus_Desc" :rules="descRules" label="Staus Desc"
                              variant="solo-filled" required></v-text-field>
                  </v-col> 
                </v-row>
                <v-row>
                  <v-col class="shrink" style="min-width: 220px;">
                    <v-text-field v-model="editedItem.RepOrderStatus_Color" v-mask="mask" hide-details class="ma-0 pa-0" solo>
                      <template v-slot:append>
                        <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                          <template v-slot:activator="{ on }">
                            <div :style="swatchStyle" v-on="on" />
                          </template>
                          <v-card>
                            <v-card-text class="pa-0">
                              <v-color-picker v-model="editedItem.RepOrderStatus_Color" flat />
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </template>
                    </v-text-field>
                  </v-col>
                 </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO STATUS</v-btn>
          </template>
          <v-card>
            <div v-if="loading">
                <v-progress-linear  color="secondary" height="6" indeterminate rounded></v-progress-linear>
            </div>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-text-field type="number" v-model="editedItem.RepOrderStatus_id" variant="solo-filled" 
                increment="1"   label="Status Id" required readonly v-show="false" :value="RepOrderStatusId"></v-text-field>

                <v-row>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editedItem.RepOrderStatus_Desc" :rules="descRules" label="Staus Desc"
                              variant="solo-filled" required></v-text-field>
                  </v-col> 
                </v-row>
                <v-row>
                  <v-col class="shrink" style="min-width: 220px;">
                    <v-text-field v-model="editedItem.RepOrderStatus_Color" v-mask="mask" hide-details class="ma-0 pa-0" solo>
                      <template v-slot:append>
                        <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                          <template v-slot:activator="{ on }">
                            <div :style="swatchStyle" v-on="on" />
                          </template>
                          <v-card>
                            <v-card-text class="pa-0">
                              <v-color-picker v-model="editedItem.RepOrderStatus_Color" flat />
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </template>
                    </v-text-field>
                  </v-col>
                 </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.RepOrderStatus_Color="{ item }">
      <v-chip :border="`${item.RepOrderStatus_Color} thin opacity-10`"  :color="item.RepOrderStatus_Color" :text="item.RepOrderStatus_Color"
      size="small">{{ item.RepOrderStatus_Color }}</v-chip>
    </template>
    
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    loading: false,
    valid: true,
    maxId: '',
		mask: '!#XXXXXXXX',
		menu: false,
    headers: [
      { text: 'Id Status', key: 'RepOrderStatus_id',value: 'RepOrderStatus_id' },
      { text: 'Staus Desc', key: 'RepOrderStatus_Desc',value: 'RepOrderStatus_Desc' },
      { text: 'Color Status', key:'RepOrderStatus_Color',value: 'RepOrderStatus_Color' },
      { text: 'Fecha Creación', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    usermenus: [],
    token: sessionStorage.getItem('access_token'),
    users: sessionStorage.getItem('ApiUser_id'),
    hora: '',
    fechaHoy: new Date().toISOString().split('T')[0],
    RepOrderStatus: [],
    editedIndex: -1,
    editedItem: {
      RepOrderStatus_id: '',
      RepOrderStatus_Desc: '',
      RepOrderStatus_Color: '',
      RepEvent_id: '',
      LastOpRepUser_id: '',
      RepEvent_Dt: '',
      RepEvent_Tm: ''
    },
    defaultItem: {
      RepOrderStatus_id: '',
      RepOrderStatus_Desc: '',
      RepOrderStatus_Color: '',
      RepEvent_id: '',
      LastOpRepUser_id: '',
      RepEvent_Dt: '',
      RepEvent_Tm: ''
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
    ],
    descRules: [
      v => !!v || 'Descripcion es requerida',
      v => (v && v.length <= 61) || 'Descripcion debe tener menos de 30 caracteres',
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Status de Ordenes' : 'Editar Status de Ordenes'
    },
    swatchStyle() {
      const color = this.editedItem.RepOrderStatus_Color
      const menu = this.menu
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_RepOrderStatus', {}, this.config)
      .then(response => {
        this.RepOrderStatus = response.data.ResultRows
      })
      .catch(error => {
        this.RepOrderStatus = []
        alert(error.response.data.message)
      })
      
    },

    newtItem (item) {
      this.editedIndex = this.RepOrderStatus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.RepOrderStatus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.RepOrderStatus.indexOf(item)
      confirm('¿Confirma la eliminación del registro?') && this.deleteUserMenu(index)
    },

    deleteUserMenu(index) {
      let usermenus_tmp = this.RepOrderStatus[index]
      //delete usermenus_tmp.RepOrderStatus_id
      axios.post(this.api_tool_url + '/del_RepOrderStatus', usermenus_tmp, this.config)
        .then(response => {
          this.RepOrderStatus.splice(index, 1)
          this.close()
          })
        .catch(error => {
          this.RepOrderStatus = []
          alert(error.response.data.message)
          })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      const ahora = new Date();
      const horas = ahora.getHours().toString().padStart(2, '0');
      const minutos = ahora.getMinutes().toString().padStart(2, '0');
      const segundos = ahora.getSeconds().toString().padStart(2, '0');
      this.hora = `${horas}:${minutos}:${segundos}`;

      this.editedItem.RepEvent_id = this.token
      this.editedItem.RepEvent_Dt = this.fechaHoy
      this.editedItem.LastOpRepUser_id = this.users
      this.editedItem.RepEvent_Tm = this.hora
      this.loading = true
      if (this.editedIndex > -1) {
        
        axios.post(this.api_tool_url + '/upd_RepOrderStatus', this.editedItem, this.config)
        .then(response => {
          Object.assign(this.RepOrderStatus[this.editedIndex], response.data.ResultRows[0])
          this.close()
          this.loading = false
          })
        .catch(error => {
          this.RepOrderStatus = []
          this.loading = false
          alert(error.response.data.message)
          })
        //Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        
        axios.post(this.api_tool_url + '/get_RepOrderStatusId', {}, this.config)
        .then(response => {
          this.editedItem.RepOrderStatus_id = response.data.ResultRows.RepOrderStatusId

          axios.post(this.api_tool_url + '/ins_RepOrderStatus', this.editedItem, this.config)
          .then(response => {
            //console.log(response)
            this.RepOrderStatus.push(response.data.ResultRows[0])
            this.close()
            this.loading = false
          })
          .catch(error => {
            this.RepOrderStatus = []
            this.loading = false
            alert(error.response.data.message)
          })


        })
        .catch(error => {
          this.RepOrderStatus = []
          this.loading = false
          alert(error.response.data.message)
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/RepOrderStatusGrid.vue